import { render } from "./TablaHistorico.vue?vue&type=template&id=281d9999&scoped=true"
import script from "./TablaHistorico.vue?vue&type=script&lang=js"
export * from "./TablaHistorico.vue?vue&type=script&lang=js"

import "./TablaHistorico.vue?vue&type=style&index=0&id=281d9999&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281d9999"]])

export default __exports__